<script>
import { mapState, mapActions } from "vuex";
import NewCoupon from "./NewCoupon";
import EditCoupon from "./EditCoupon";
import AddDistricts from "./AddDistricts/Index";
import Pagination from "@/components/_Shared/Pagination";
import PreloaderTable from "@/components/_Shared/PreloaderTable";
import dateMixin from "@/mixins/dateMixin";
import numberMixin from "@/mixins/numberMixin";
import moment from "@/utils/moment";

export default {
  title: "Cupons",
  mixins: [dateMixin, numberMixin],
  filters: {
    state(val) {
      return moment(val) < moment() ? "expirado" : "ativo";
    }
  },
  data() {
    return {
      newCoupon: false,
      updateCoupon: false,
      snackbarError: false,
      errorMessage: "",
      addDistrict: false,
      selected: null,
      search: "",
      newCouponComponentKey: 0
    };
  },
  components: {
    NewCoupon,
    EditCoupon,
    AddDistricts,
    Pagination,
    PreloaderTable
  },
  computed: {
    ...mapState("coupons", [
      "list",
      "preloader",
      "pagination",
      "sort",
      "text_search"
    ])
  },
  methods: {
    ...mapActions("coupons", [
      "listAll",
      "setCurrentPage",
      "setSort",
      "setTextSearch"
    ]),
    setSelected(coupon) {
      this.selected = coupon;
    },
    showAddDistrict(event) {
      this.addDistrict = true;
      event.stopPropagation();
    },
    showEditCoupon(event) {
      this.updateCoupon = true;
      event.stopPropagation();
    },
    inPast(date) {
      return moment(date) < moment();
    },
    setErrorMessage(val) {
      this.errorMessage = val;
    },
    activeSnackbarError(val) {
      this.snackbarError = val;
    },
    forceRerenderNewCouponComponent() {
      this.newCouponComponentKey += 1;
    },
    input(value) {
      this.setCurrentPage(value);
    }
  },
  watch: {
    list(val) {
      if (this.selected)
        this.selected = val.find(el => el.id === this.selected.id);
    }
  },
  mounted() {
    if (!this.list || !this.list.length) this.listAll();
  }
};
</script>

<template>
  <div class="box">
    <div class="title">cupons</div>

    <v-layout column justify-start>
      <v-layout row>
        <div class="new-group" @click="newCoupon = !newCoupon">
          <img src="../../../static/plus.svg" /> Cadastrar novo cupom
        </div>
      </v-layout>

      <v-layout justify-start row wrap>
        <input
          type="text"
          v-model="search"
          @keyup.enter="setTextSearch(search)"
          placeholder="buscar"
          class="with-icon icon-search sm text-lowercase"
        />
        <v-btn color="primary" text small @click="setTextSearch(search)">
          <span>busca avançada</span>
        </v-btn>
      </v-layout>
    </v-layout>

    <transition name="fade" mode="out-in">
      <PreloaderTable v-if="preloader" />
      <div key="1" v-else class="table">
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Situação</th>
              <th>Validade</th>
              <th>Bairros</th>
              <th>Data de criação</th>
              <th>Desconto</th>
              <th>N° de usos</th>
              <th>Ação</th>
            </tr>
          </thead>

          <transition name="fade" mode="out-in">
            <tbody>
              <template v-for="coupon in list">
                <tr
                  class="pointer"
                  :key="coupon.id"
                  @click="setSelected(coupon)"
                >
                  <td>{{ coupon.name }}</td>
                  <td>{{ coupon.expires_at | state }}</td>
                  <td>{{ coupon.expires_at | formatDate }}</td>
                  <td v-if="coupon.coupon_type === 'UNRESTRICTED'">
                    sem restrição
                  </td>
                  <td v-else>{{ coupon.districts.length }}</td>
                  <td>{{ coupon.created_at | formatDate("DD/MM/Y") }}</td>
                  <td v-if="coupon.value_type === 'VALUE'">
                    {{ coupon.value | intToCurrency }}
                  </td>
                  <td v-else>{{ coupon.value }}%</td>
                  <td>0</td>
                  <td nowrap class="buttons">
                    <div
                      v-if="
                        selected &&
                          selected.id === coupon.id &&
                          !inPast(coupon.expires_at) &&
                          coupon.coupon_type !== 'UNRESTRICTED'
                      "
                      class="btn btn-small bg-purple-outline float-right"
                      @click="showAddDistrict"
                    >
                      adicionar distrito
                    </div>
                    <div
                      v-if="selected && selected.id === coupon.id"
                      class="btn btn-small bg-purple-outline float-right"
                      @click="showEditCoupon"
                    >
                      editar
                    </div>
                  </td>
                </tr>

                <tr
                  v-if="
                    selected &&
                      selected.id == coupon.id &&
                      selected.districts.length
                  "
                  class="nested-table"
                  :key="coupon.id + '-nested'"
                >
                  <td colspan="8">
                    <table>
                      <thead>
                        <th>Distrito</th>
                        <th>Cidade</th>
                        <th>Valor</th>
                        <th>Taxa</th>
                        <th>Nota Mínima</th>
                        <th>Nota Máxima</th>
                        <th>Atualizado em</th>
                        <th></th>
                      </thead>

                      <tbody>
                        <tr
                          v-for="district in selected.districts"
                          :key="district.id"
                        >
                          <td>{{ district.display_name }}</td>
                          <td>{{ district.city.display_name }}</td>
                          <td>
                            R$
                            {{ district.pricing.price_per_hour | intToDecimal }}
                          </td>
                          <td>
                            R$
                            {{ district.pricing.fee_per_hour | intToDecimal }}
                          </td>
                          <td>
                            {{ district.rating.rating_min | intToDecimal }}%
                          </td>
                          <td>
                            {{ district.rating.rating_max | intToDecimal }}%
                          </td>
                          <td>
                            {{
                              [
                                district.updated_at,
                                district.rating.updated_at,
                                district.pricing.updated_at
                              ]
                                | greaterDate
                                | formatDate
                            }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </template>
            </tbody>
          </transition>
        </table>

        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="pagination.current"
            :total-visible="7"
            :length="pagination.totalPages"
            @input="input"
            circle
          ></v-pagination>
        </div>
      </div>
    </transition>

    <NewCoupon
      v-show="newCoupon"
      :key="newCouponComponentKey"
      @close="newCoupon = false"
      @refresh="listAll() && forceRerenderNewCouponComponent()"
      v-on:errorMessage="setErrorMessage"
      v-on:snackbarError="activeSnackbarError"
    />

    <AddDistricts
      v-if="addDistrict"
      :districts="selected.districts"
      :coupon_id="selected.id"
      @close="
        addDistrict = false;
        listAll();
      "
      @refresh="listAll()"
    />

    <EditCoupon
      v-if="updateCoupon"
      :coupon="JSON.parse(JSON.stringify(selected))"
      @close="updateCoupon = false"
      @refresh="listAll()"
      v-on:errorMessage="setErrorMessage"
      v-on:snackbarError="activeSnackbarError"
    />

    <v-snackbar v-model="snackbarError" color="error">
      <span>{{ this.errorMessage }}</span>
      <v-btn text @click="snackbarError = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Coupons/Index.vue